/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");
var prop = require("prop");

module.exports = Model({
	name: "workflowinstances",
	init: init,
	triggers: triggers,
	listeners: listeners,

	recalculate: recalculate,

	_people: {},
	_definitions: {},
	_instances: {},
	_tracking: [],
});

function init() {
	this.push({});
}

function triggers(){
	return {
		"track": track
	};
}

function listeners(){
	return {
		"workflowdefinitions:updated": Model.makeRecalculator("definitions"),
		"people:updated": Model.makeRecalculator("people"),
		// TODO: Handle changes to actors
	};
}

function recalculate() {
	var definitions = this._definitions;
	var instances = this._instances;
	var people = this._people;

	var newValue = Object.keys(instances).reduce(function (result, key) {
		var instance = instances[key];
		var definition = definitions[instance.workflow];
		var actors = instance.actors.reduce(function (actorResult, actor) {
			var actorData = people[actor.who];
			if (actorData)
				return actorResult.concat({
					actor: actor.actor,
					who: actorData
				});
			return actorResult;
		}, []);
		var owner = people[instance.owner];

		if (definition && owner)
			result[key] = xtend(instance, {
				owner: owner,
				actors: actors,
				workflow: definition.schema,
				workflowId: instance.workflow,
				externals: definition.externals
			});

		return result;
	}, {});

	if(!Object.keys(this.data) && !Object.keys(newValue))
		return;

	this.push(newValue);
}

function track(data) {
	var workflows = data.workflows;

	var newWorkflows = workflows.filter(function(workflow){
		return this._tracking.indexOf(workflow) === -1;
	}, this);

	if(!newWorkflows.length) return;

	var deDuped = newWorkflows.reduce(function(result, item){
		if(result.indexOf(item) === -1)
			return result.concat(item);
		return result;
	}, []);

	this._tracking = this._tracking.concat(deDuped);

	deDuped.map(loadDefinition, this);
}

function loadDefinition(definition) {
	this.api
		.workflow.data(definition)
		.then(handle_loaded.bind(this, definition))
		.catch(console.error.bind(console));
}

function handle_loaded(id, definition) {
	var update = {};
	update[id] = definition;
	this._instances = xtend(this._instances, update);

	var workflowDefintion = definition.workflow;

	this.emit("workflowdefinitions:trigger:track", {
		definitions: [workflowDefintion]
	});

	var toTrackPeople = definition
		.actors
		.map(prop("who"))
		.concat(definition.owner);

	this.emit("people:trigger:add", {
		lean: true,
		who: toTrackPeople
	});

	this.recalculate();
}
